// @ts-nocheck

import { useEffect } from "react";

const TRACKING_ID = "187241374";

function loadScript() {
  (function (w, d, t, r, u) {
    var f, n, i;
    ((w[u] = w[u] || []),
      (f = function () {
        var o = {
          ti: TRACKING_ID,
          enableAutoSpaTracking: true,
          ts: new Date().getTime(),
        };
        ((o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad"));
      }),
      (n = d.createElement(t)),
      (n.src = r),
      (n.async = 1),
      (n.onload = n.onreadystatechange =
        function () {
          var s = this.readyState;
          (s && s !== "loaded" && s !== "complete") ||
            (f(), (n.onload = n.onreadystatechange = null));
        }),
      (i = d.getElementsByTagName(t)[0]),
      i.parentNode.insertBefore(n, i));
  })(
    window,
    document,
    "script",
    "https://bat.bing.net/bat.js?ti=" + TRACKING_ID,
    "uetq"
  );
}

function useBingAnalytics(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useBingAnalytics;
